export enum ShipmentWaybillEndpoint {
  Adaptation = '/adaptation',
  Base = '/shipments',
  Count = '/count',
  Comments = '/comments',
  ContainerCharges = '/container-charges',
  CustomsDocuments = '/customs-documents',
  Equipments = '/equipments',
  GoodsItems = '/goods-items',
  Waybills = '/waybills',
  Summary = '/summary',
  Status = '/status',
  TrackingMap = '/tracking-map',
  Milestones = '/milestones',
  Materials = '/materials',
  Notifications = '/notifications',
  StatusHistory = '/status-history',
  Available = '/available',
}
